import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/photo-gallery-approval-workflow-system/components/PhotoGalleryClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/RouteGuard.tsx");
